import React from 'react'
import styled from 'styled-components'
import { financeColors } from '../tokens'

interface Props {
  title?: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
}

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
`

const Copy = styled.div`
  display: grid;
  gap: 8px;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${financeColors.text};
`

const Description = styled.div`
  color: ${financeColors.textSoft};
  font-size: 14px;
  line-height: 1.6;
`

const FinanceCardHeader: React.FC<Props> = ({
  title,
  description,
  actions,
}) => {
  if (!title && !description && !actions) {
    return null
  }

  return (
    <Wrap>
      <Copy>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
      </Copy>
      {actions}
    </Wrap>
  )
}

export default FinanceCardHeader
